import { render, staticRenderFns } from "./header-study.vue?vue&type=template&id=be73220e&scoped=true&"
import script from "./header-study.vue?vue&type=script&lang=js&"
export * from "./header-study.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be73220e",
  null
  
)

export default component.exports